<template>
  <div class="storageDaPing">
    <div class="title" style="position: relative;">
      <img src="../../assets/cangchuDaping/blue.png" alt class="img1" />
      <div class="h2">
       苏美达专属库作业看板
      </div>
      <img src="../../assets/cangchuDaping/blue.png" alt class="img2" />
      <span class="tiaozhuan">
        {{ nowDate + ' ' + nowWeek }}
      </span>
    </div>
    <!-- 主体 -->
    <div class="conent">
      <div class="topsgn" style="height: 59vh;width: 100%; display: flex;">
        <div class="topLeft" style="width: 25%;">
          <div style="height: 29vh;width: 100%;margin-bottom:1vh;" class="topCon">
            <div class="leftTop"></div>
            <div class="leftBottom"></div>
            <div class="rightTop"></div>
            <div class="rightBottom"></div>
            <div class="topCon_title" >
              <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1"  style="height:auto"/>
              仓库列表
              <img
                src="../../assets/cangchuDaping/some_blue.png"
                alt style="height:auto"
                class="img2"
              />
            </div>
            <div style="height: 26vh;width: 100%;" id="table" @click="xqFn">
              <div class="tables">
                <span class="span_one">仓库名称</span>
                <span class="span_one">查看详情</span>
                <span class="span_one">视频监控</span>
              </div>
              <vue-seamless-scroll
                :data="ckList"
                :class-option="optionSetting"
                class="seamless-warp2"
              >
                <ul class="item">
                  <li
                    v-for="(item,index) in ckList"
                    :key="index"
                    :style="item.timeDifference>120?'color:red':item.timeDifference>60?'color:yellow':''"
                  >
                    <span v-text="item.remark"></span>
                    <span  style="cursor: pointer;">
                      <a :href="global.baseUrl + '/#/bulkCargoDetails' + '?name=' + item.remark" target="_blank"
                       rel="noopener noreferrer" style=" color: #00ffff;text-decoration: none;">
                      查看</a>
                    </span>
                    <span :data-row="item.remark"> <i class="fa fa-camera" style=" color: #00ffff;" :data-row="item.remark" aria-hidden="true" /></i></a>
                    </span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
          <div style="height: 29vh;width: 100%;" class="topCon">
            <div class="leftTop"></div>
            <div class="leftBottom"></div>
            <div class="rightTop"></div>
            <div class="rightBottom"></div>
            <div class="topCon_title" >
              <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1"  style="height:auto"/>
              实时库存总量
              <img  src="../../assets/cangchuDaping/some_blue.png" alt style="height:auto" class="img2" />
            </div>
            <div style="height: 26vh;width: 100%;" id="myChart" ></div>
          </div>
        </div>
        <div style="width:1%;height:100%;"></div>
        <div class="topCenter topCon"  style="width: 48%;height: 59vh;" >
          <div class="leftTop"></div>
          <div class="leftBottom"></div>
          <div class="rightTop"></div>
          <div class="rightBottom"></div>
          <div id="map" style="height: 100%;width: 100%;"></div>
        </div>
        <div style="width:1%;height:100%;"></div>
        <div class="topRight"  style="width: 25%;">
          <div style="height: 29vh;width: 100%;;margin-bottom:1vh" class="topCon">
            <div class="leftTop"></div>
            <div class="leftBottom"></div>
            <div class="rightTop"></div>
            <div class="rightBottom"></div>
            <div class="topCon_title" >
              <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1"  style="height:auto"/>
              当日入库量
              <img  src="../../assets/cangchuDaping/some_blue.png" alt style="height:auto" class="img2" />
            </div>
            <div style="height: 26vh;width: 100%;" id="rklPie"></div>
          </div>
          <div style="height: 29vh;width: 100%;" class="topCon">
            <div class="leftTop"></div>
            <div class="leftBottom"></div>
            <div class="rightTop"></div>
            <div class="rightBottom"></div>
            <div class="topCon_title" >
              <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1"  style="height:auto"/>
              当日出库量
              <img  src="../../assets/cangchuDaping/some_blue.png" alt style="height:auto" class="img2" />
            </div>
            <div style="height: 26vh;width: 100%;" id="cklPie"></div>
          </div>
        </div>
      </div>
      <div class="bottomsgn" style="height: 33vh;width: 100%;display: flex;margin-top: 1vh;">
        <div class="bottomLeft topCon">
          <div class="leftTop"></div>
          <div class="leftBottom"></div>
          <div class="rightTop"></div>
          <div class="rightBottom"></div>
          <div class="topCon_title" >
            <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1"  style="height:auto"/>
            历史库存量波动
            <img  src="../../assets/cangchuDaping/some_blue.png" alt style="height:auto" class="img2" />
          </div>
          <div style="height: 30vh;width: 100%;" id="kuCunChart1"></div>
        </div>
        <div style="width:1%;height:100%;"></div>
        <div class="bottomCenter topCon">
          <div class="leftTop"></div>
          <div class="leftBottom"></div>
          <div class="rightTop"></div>
          <div class="rightBottom"></div>
          <div class="topCon_title" >
            <img src="../../assets/cangchuDaping/some_blue.png" alt class="img1"  style="height:auto"/>
            历史出入库波动
            <img  src="../../assets/cangchuDaping/some_blue.png" alt style="height:auto" class="img2" />
          </div>
          <div style="height: 30vh;width: 100%;" id="rChart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findShWhList, // 仓库列表
  findInventoryQuantityByWh, // 1饼图
  findOperationQuantityByWh, // 日入库量日出库量
  findInventoryQuantityFluctuationByWh, //  库存量波动
  findInOutQuantityFluctuationByWh // 历史出入库波动
} from '@/api/data-center-server'
import { equipmentList } from '@/api/video'
import DonMessage from '@/utils/message'
import 'echarts-liquidfill/src/liquidFill.js' // 在这里引入
import global from '@/api/global'

export default {
  data () {
    return {
      nowDate: '', // 当前日期
      nowWeek: '', // 当前星期
      ckList: [],
      // 库存量波动
      stockDateList: [], // 5-日期
      weightSumList: [], // 5-1库存
      stockDateListSlice: [],
      weightSumListSlice: [],
      // 出入库量波动
      instockDateList: [],
      instockWeightList: [],
      outstockDateList: [],
      outstockWeightList: [],
      instockDateListSlice: [],
      instockWeightListSlice: [],
      outstockDateListSlice: [],
      outstockWeightListSlice: []
    }
  },

  computed: {
    optionSetting () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 9, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted () {
    this.getDate()
    this.getcangku()
    this.pieFN()// 实时库存总量 饼图1
    this.getruchuData()// 日入库量 日出库量 饼图2 饼图3
    this.lskcbdFn()// 历史库存量波动
    this.lscrkbdFn()// 历史出入库波动
  },
  methods: {
    // 历史出入库波动
    lscrkbdFn () {
      findInOutQuantityFluctuationByWh()
        .then(res => {
          // instock outstock
          res.in.forEach((item, index) => {
            this.instockDateList.push(item.stockDate) // 入库数据-日期
            this.instockWeightList.push(item.weightSum) // 入库数据-数据量
          })
          res.out.forEach((item, index) => {
            this.outstockDateList.push(item.stockDate) // 出库数据-日期
            this.outstockWeightList.push(item.weightSum) // 出库数据-数据
          })
          this.instockDateListSlice = this.instockDateList.slice(-9)
          this.instockWeightListSlice = this.instockWeightList.slice(-9)
          this.outstockDateListSlice = this.outstockDateList.slice(-9)
          this.outstockWeightListSlice = this.outstockWeightList.slice(-9)
          // 日出库量
          let rChart = this.$echarts.init(document.getElementById('rChart'))

          // 绘制图表--日出入库波动
          rChart.setOption({
            tooltip: {
              trigger: 'axis',
              backgroundColor: 'rgba(255,255,255,0.8)', // 通过设置rgba调节背景颜色与透明度
              color: 'black',
              borderWidth: '1',
              borderColor: 'gray',
              textStyle: {
                color: 'black'
              },
              // backgroundColor: 'rgba(255,255,255,1)',
              padding: [5, 10],

              extraCssText: 'box-shadow: 0 0 5px rgba(0,0,0,0.3)'
            },
            legend: {
              right: 20,
              orient: 'vertical',
              color: '#fff',
              data: ['日入库', '日出库'],
              textStyle: {
                color: '#fff'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: this.instockDateListSlice,
                boundaryGap: false,
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    width: 1 // 粗细
                  }
                },
                // 虚线设置
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#0898BA',
                    type: 'dashed'
                  }
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                data: ['0', '100', '200', '300', '400', '500', '600'],
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    width: 1 // 粗细
                  }
                },
                // 虚线设置
                splitLine: {
                  show: false,
                  lineStyle: {
                    color: '#0898BA',
                    type: 'dashed'
                  }
                }
              }
            ],
            series: [
              {
                name: '日入库',
                type: 'line',
                smooth: true,
                showSymbol: false,
                symbol: 'circle',
                symbolSize: 6,
                data: this.instockWeightListSlice,
                itemStyle: {
                  normal: {
                    color: '#f7b851'
                  }
                },
                lineStyle: {
                  normal: {
                    width: 3
                  }
                }
              },
              {
                name: '日出库',
                type: 'line',
                smooth: true,
                showSymbol: false,
                symbol: 'circle',
                symbolSize: 6,
                data: this.outstockWeightListSlice,

                itemStyle: {
                  normal: {
                    color: '#58c8da'
                  }
                },
                lineStyle: {
                  normal: {
                    width: 3
                  }
                }
              }
            ]
          })
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 历史库存量波动统计-柱状图
    lskcbdFn () {
      findInventoryQuantityFluctuationByWh()
        .then(res => {
          // stockDate: "2020-04-21"
          // weightSum: "0"
          res.forEach((item, index) => {
            item.stockDate = item.stockDate.slice(5) // 截取第二个之后所有的字符 cdef
            this.stockDateList.push(item.stockDate)
            this.weightSumList.push(item.weightSum)
          })
          this.stockDateListSlice = this.stockDateList.slice(-9)
          this.weightSumListSlice = this.weightSumList.slice(-9)

          // 库存量
          let kuCunChart1 = this.$echarts.init(
            document.getElementById('kuCunChart1')
          )
          // 绘制图表--库存量
          kuCunChart1.setOption({
            color: ['#E8EB38'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: this.stockDateListSlice,
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    // color: '#fff', // 颜色
                    width: 1 // 粗细
                  }
                }
              }
            ],
            yAxis: [
              {
                type: 'value',

                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#A1C9D9'
                  }
                },
                // 边框设置
                axisLine: {
                  lineStyle: {
                    color: '#0898BA',
                    // color: '#fff', // 颜色
                    width: 1 // 粗细
                  }
                },
                // 虚线设置
                splitLine: {
                  show: true,
                  lineStyle: {
                    type: 'dashed',
                    color: '#0898BA'
                  }
                }
              }
            ],
            series: [
              {
                name: '库存量',
                type: 'bar',
                barWidth: '20%',
                data: this.weightSumListSlice
              }
            ]
          })
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 日入库量 日出库量
    getruchuData () {
      findOperationQuantityByWh().then(res => {
        this.pie2(res.inList, res.inAllWeight)
        this.pie3(res.outList, res.outAllWeight)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    pie3 (data, inAllWeight) {
      let _this = this
      let idChart = _this.$echarts.init(document.getElementById('cklPie'))
      var dataArr = []
      var color = ['#00ffff', '#00cfff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#00ffff']
      for (var i = 0; i < data.length; i++) {
        dataArr.push({
          value: data[i].weightSum,
          name: data[i].organizationName
        })
      }

      var option = {
        backgroundColor: 'rgba(225,225,225,0)',
        color: color,
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        visualMap: {
          show: false,
          min: 500,
          max: 600,
          inRange: {
            // colorLightness: [0, 1]
          }
        },
        series: [
          {
            name: '出库量',
            type: 'pie',
            radius: '50%',
            center: ['50%', '50%'],
            color: ['rgb(131,249,103)', '#FBFE27', '#FE5050', '#1DB7E5'], // '#FBFE27','rgb(11,228,96)','#FE5050'
            data: dataArr.sort(function (a, b) {
              return a.value - b.value
            }),
            roseType: 'radius',
            label: {
              normal: {
                formatter: ['{c|{c}}', '{b|{b}}'].join('\n'),
                rich: {
                  c: {
                    color: 'rgb(241,246,104)',
                    fontSize: 14,
                    fontWeight: 'bold',
                    lineHeight: 5
                  },
                  b: {
                    color: 'rgb(98,137,169)',
                    fontSize: 15,
                    height: 40
                  }
                }
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgb(98,137,169)'
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0, 0, 0, 0.8)',
                shadowBlur: 50
              }
            }
          }
        ]
      }
      idChart.setOption(option)
    },
    pie2 (data, inAllWeight) {
      let _this = this
      var img = 'data:image/png;base64,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'
      let idChart = _this.$echarts.init(document.getElementById('rklPie'))
      var dataArr = []
      var color = ['#00ffff', '#00cfff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#00ffff']
      for (var i = 0; i < data.length; i++) {
        dataArr.push({
          value: data[i].weightSum,
          name: data[i].organizationName,
          itemStyle: {
            normal: {
              borderWidth: 5,
              shadowBlur: 20,
              borderColor: color[i],
              shadowColor: color[i]
            }
          }
        }, {
          value: 1,
          name: '',
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              color: 'rgba(0, 0, 0, 0)',
              borderColor: 'rgba(0, 0, 0, 0)',
              borderWidth: 0
            }
          }
        })
      }
      var seriesOption = [{
        name: '',
        type: 'pie',
        clockWise: false,
        radius: [70, 75],
        hoverAnimation: false,
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'outside',
              color: '#ddd',
              formatter: function (params) {
                if (params.name) {
                  return params.name + ':' + params.value
                }
              }
            }
          }
        },
        data: dataArr
      }]
      var option = {
        backgroundColor: 'rgba(225,225,225,0)',
        color: color,
        title: {
          text: '入库量\n' + '\n' + inAllWeight,
          top: '48%',
          textAlign: 'center',
          left: '49%',
          textStyle: {
            color: '#fff',
            fontSize: 14,
            fontWeight: '400'
          }
        },
        graphic: {
          elements: [{
            type: 'image',
            z: 3,
            style: {
              image: img,
              width: 128,
              height: 128
            },
            left: 'center',
            top: 'center',
            position: [100, 100]
          }]
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.5)',
          formatter: function (params) {
            var percent = 0
            if (inAllWeight == 0) {
              percent = 0
            } else {
              percent = ((params.value / inAllWeight) * 100).toFixed(0)
            }

            return params.marker + '<span style="color:' + params.color + '">' + params.data['name'] + '\n' + params.data['value'] + '</span></br>' + '占百分比：' + percent + '%'
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        series: seriesOption
      }
      idChart.setOption(option)
    },
    //  实时库存总量--饼图
    pieFN () {
      findInventoryQuantityByWh().then(res => {
        let obj = {}
        obj.organizationName = '暂无信息'
        obj.stockWeight = 0
        // 如果res为【】，制造数据进去
        if (!res.customerList) {
          res.customerList = []
          res.customerList.push(obj)
          this.sum = 0
        }
        this.bingTuList = res.customerList
        this.storageData = []
        this.allWeight = []
        this.sum = 0
        this.bingTuList.forEach((item, index) => {
          this.allWeight.push(item.allWeight)

          let name = item.organizationName // customerName客户名称
          let keHuvalue = item.stockWeight // allweight库存量
          let _storage = {}
          _storage['name'] = name
          _storage['value'] = keHuvalue
          this.storageData.push(_storage) // 饼图使用的数据
        })
        this.sum = res.allWeight ? res.allWeight : 0

        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表--库存量
        myChart.setOption({
          color: [
            '#38C3B0',
            '#86CA5A',
            '#BFD44F',
            '#FCC248',
            '#FCE448',
            '#F58B41',
            '#F7765B',
            '#525ECD',
            '#547FDB'
          ],
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} '
          },
          title: {
            text: '库存总量\n' + '\n' + this.sum,
            left: 'center',
            top: '40%',
            textStyle: {
              color: '#fff',
              fontWeight: 'normal',
              fontSize: 14
            }
          },
          graphic: [
            {
              type: 'group',
              top: 'middle',
              left: 'center',
              id: 'data'
            }
          ],
          series: [
            {
              name: '库存总量',
              type: 'pie',
              clickable: true, // 是否开启点击
              minAngle: 5, // 最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true, // 是否启用防止标签重叠策略

              radius: ['40%', '55%'],
              center: ['50%', '50%'],
              labelLine: {
                normal: {
                  length: 1
                }
              },
              data: this.storageData,

              label: {
                align: 'left',
                normal: {
                  formatter (v) {
                    let text = v.name + ':' + v.value
                    if (text.length <= 4) {
                      return text
                    } else if (text.length > 4 && text.length <= 10) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(4)}`)
                    } else if (text.length > 10 && text.length <= 18) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(
                        4,
                        10
                      )}\n${text.slice(10)}`)
                    } else if (text.length > 18 && text.length <= 30) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(
                        4,
                        10
                      )}\n${text.slice(10, 18)}\n${text.slice(18)}`)
                    } else if (text.length > 30) {
                      return (text = `${text.slice(0, 4)}\n${text.slice(
                        4,
                        10
                      )}\n${text.slice(10, 18)}\n${text.slice(
                        18,
                        30
                      )}\n${text.slice(30)}`)
                    }
                  },
                  textStyle: {
                    fontSize: 8
                    // color: '#fff'
                  }
                }
              }
            }
          ]
        })
      })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 仓库列表 地图
    getcangku () {
      findShWhList().then(res => {
        this.ckList = res
        let arr = []
        res.forEach(itme => {
          arr.push({
            name: itme.remark,
            value: [itme.updateUserId, itme.updateUser]
          })
        })
        this.getmap(arr)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 地图
    getmap (ckList) {
      // 初始化echarts实例
      let _this = this
      let myChart = _this.$echarts.init(document.getElementById('map'))
      // 图标
      let iconCK = 'image://data:image/png;base64,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'
      let chartOption = {
        color: ['#fdfd01'],
        tooltip: {
          // 鼠标移到图里面的浮动提示框
          // formatter详细配置： https://echarts.baidu.com/option.html#tooltip.formatter
          formatter (params, ticket, callback) {
            let htmlStr = `
                <div style='font-size:18px;'> ${params.name}</div>
              `
            return htmlStr
          }
        },
        // backgroundColor:"#ff7f50",//提示标签背景颜色
        //
        // 图例
        // legend: {
        //   orient: 'vertical',
        //   id: 1,
        //   y: 'top',
        //   x: 'right',
        //   itemWidth: 15,
        //   data: [
        //     {
        //       name: '码头'
        //       // icon: iconMT
        //     },
        //     {
        //       name: '仓库',
        //       icon: iconCK
        //     }
        //   ],
        //   textStyle: {
        //     color: '#fff'
        //   }
        // },
        geo: {
          // 地理坐标系组件用于地图的绘制
          map: 'china', // 表示中国地图
          roam: true, // 是否开启鼠标缩放和平移漫游
          zoom: 1.3, // 当前视角的缩放比例（地图的放大比例）
          // center: [117.232389, 31.311958],
          scaleLimit: { // 滚轮缩放的极限控制
            min: 1
          },
          label: {
            show: true,
            color: '#03faec'
          },
          itemStyle: {
            // 地图区域的多边形 图形样式。
            borderColor: 'rgba(0, 0, 0, 0.2)',
            normal: {
              areaColor: '#01145D', // 区域背景色 地图
              borderColor: '#03DBD9' // 每个区域的边框色
            },
            emphasis: {
              areaColor: '#02229b' // 区域背景色 点击后颜色
            }
          },
          emphasis: {
            label: {
              color: '#00FFFF'
            }
          }
        },
        series: [
          // 仓坐标
          {
            name: '仓库',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: ckList,
            symbol: iconCK,
            symbolSize: 26,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  if (params.data.isUsed == 1) {
                    return ''
                  } else {
                    return params.name
                  }
                },
                position: 'bottom',
                color: '#fff',
                fontSize: '11'
              },
              emphasis: {
                show: false,
                color: '#00d5e9'
              }
            }
          }
        ]
      }
      myChart.setOption(chartOption)
    },
    // 查看详情
    xqFn (e) {
      console.log(e.target.dataset)
      try {
        const name = e.target.dataset.row
        if (name) {
          equipmentList({ tenantName: name }).then(res => {
            if (res.length > 0) {
              window.open(global.baseUrl + '/#/monitor' + '?name=' + name)
            } else {
              this.$alert('暂无可查看的监控', '系统提示')
            }
          }).catch(error => {
            this.$message.error(error)
          })
        }
      } catch (error) {
        console.log('JSON parse error>>>>>>>>>>>>>>>>>>', error)
      }
    },
    // 获取当前时间
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style lang='less' scoped>
.storageDaPing {
  height: 100vh;
  padding: 10px;
  overflow: hidden;
  box-sizing: border-box;
  background: url("../../assets/cangchuDaping/bj.jpg") no-repeat 100%;
}
/* 头部 */
.title {
  height: 4vh;
  line-height: 4vh;
  width: 100%;
  display: flex;
  justify-content:center;
  align-items:center;
  // background: url("../../../assets/cangchuDaping/blue.png") no-repeat center;
  .img1 {
    height: 1vh;
  }
  .img2 {
    height: 1vh;
  }
  .h2 {
    color: #00ffff;
    font-size: 22px;
  }
}
/* 主体 */
.conent {
  height: 93vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1vh;
  .flexBox {
    flex: 1;
    display: flex;
    .top {
      flex: 1;
    }
    .top_left {
      display: flex;
      .topCon {
        flex: 1;
      }
    }
    .center {
      flex: 1;
      width: 40vmax;
    }
  }
  .conent_center {
    margin-top: 1vh;
  }
  .topCon {
    position: relative;
    flex: 1;
    background: rgba(46, 43, 43, 0.13);
    .left_top_one {
      background-size: cover;
    }
    .topCon_body {
      width: 100%;
    }
    .leftTop {
      position: absolute;
      left: 0;
      top: 0;
      width: 10px;
      height: 10px;
      border-top: 2px solid #00ffff;
      border-left: 2px solid #00ffff;
    }
    .leftBottom {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 10px;
      height: 10px;
      border-bottom: 2px solid #00ffff;
      border-left: 2px solid #00ffff;
    }
    .rightBottom {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 10px;
      height: 10px;
      border-bottom: 2px solid #00ffff;
      border-right: 2px solid #00ffff;
    }
    .rightTop {
      position: absolute;
      right: 0;
      top: 0;
      width: 10px;
      height: 10px;
      border-right: 2px solid #00ffff;
      border-top: 2px solid #00ffff;
    }
  }
  .topCon_title {
    width: 100%;
    color: #00ffff;
    height: 3vh;
    line-height: 3vh;
    text-align: center;
    background-color: #082153;
    font-size: 13px;
  }
}
//表格滚动
#table {
  width: 100%;
  font-size: 12px;
  // height: 3vh;
  overflow: hidden;
  .tables {
    background-color: #0565f7;
    width: 100%;
    color: #fff;
    height: 2vh;
    line-height: 2vh;
    display: flex;
    text-align: center;
    span {
      flex: 1;
    }
    .span_one {
      width: 120px;
      height: 100%;
    }
  }
  .seamless-warp {
    height: 40vh;
    width: 100%;
    overflow: hidden;
    ul {
      margin-top: 10px;
    }
    li {
      display: flex;
      width: 100%;
      height: 3vh;
      line-height: 3vh;
      color: #fff;
      span {
        flex: 1;
        // width: 40%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // padding: 0 2px;
        text-align: center;
      }
      // .oneSpan {
      //   color: red;
      //   flex-shrink: 0;
      // }
      .span {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    #text {
      padding-left: 4vmax;
      font-size: 14px;
      height: 4vh;
      line-height: 4vh;
    }
    .colorYellow {
      // border: 1px solid yellow;
      color: #eed808;
    }
  }
}
.seamless-warp2 {
  height: 40vh;
  width: 100%;
  overflow: hidden;
  ul {
    margin-top: 10px;
  }
  li {
    display: flex;
    width: 100%;
    height: 3vh;
    line-height: 3vh;
    color: #fff;
    span {
      flex: 1;
      // width: 40%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // padding: 0 2px;
      text-align: center;
    }
    // .oneSpan {
    //   color: red;
    //   flex-shrink: 0;
    // }
    .span {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  #text {
    padding-left: 4vmax;
    font-size: 14px;
    height: 4vh;
    line-height: 4vh;
  }
  .colorYellow {
    // border: 1px solid yellow;
    color: #eed808;
  }
}

.tiaozhuan{
  color: #00ffff;
  position: absolute;
  right: 10px;
  text-decoration: none;
}
</style>
